import LoopingEllipsis from '@/components/LoopingEllipsis';
import { classes } from './utils';

export interface LoadingCardProps {
  message: string;
}

export default function LoadingCard({ message }: LoadingCardProps) {
  return (
    <div className={classes.card}>
      <div className={classes.spinner}>
        <div className={classes.ring} />
        <div className={classes.logoTile}>
          <img
            className={classes.logo}
            src="/images/sweeth_logo_condensed.svg"
            alt="Sweeth logo"
          />
        </div>
      </div>
      <div className={classes.text}>
        <span>{message}</span>
        <LoopingEllipsis />
      </div>
    </div>
  );
}
